/**
 * Whether this browser shows a PDF inside an iframe. A browser whose PDF
 * viewer is off says so directly (`pdfViewerEnabled`), and iOS and iPadOS
 * Safari show only a still of the first page, so the file viewer offers the
 * file card with Download instead. The UI's one read of these navigator
 * fields.
 */

const IOS_DEVICE_PATTERN = /iPad|iPhone|iPod/;
/** iPadOS 13+ reports itself as a Mac; only the iPad has a touch screen. */
const MAC_PATTERN = /Macintosh/;
const MAC_MAX_TOUCH_POINTS = 1;

function isIPadPosingAsMac(userAgent: string, maxTouchPoints: number): boolean {
  return MAC_PATTERN.test(userAgent) && maxTouchPoints > MAC_MAX_TOUCH_POINTS;
}

export function browserShowsPdfInline(): boolean {
  const { userAgent, maxTouchPoints, pdfViewerEnabled } = navigator;
  // Only an explicit false counts: browsers that predate the field leave it undefined.
  if (pdfViewerEnabled === false) return false;
  if (IOS_DEVICE_PATTERN.test(userAgent)) return false;
  return !isIPadPosingAsMac(userAgent, maxTouchPoints);
}
